import { telHref } from '../widget-lib/phone-tel';

/**
 * Разбивает произвольный текст (часы, примечания) и делает распознанные номера телефонов ссылками tel:.
 */
export function TextWithPhoneLinks(props: { text: string; className?: string }) {
  const { text, className = 'text-sm leading-relaxed text-[var(--text)]' } = props;
  const segments = splitTextWithPhones(text);
  const first = segments[0];
  if (segments.length === 1 && first && first.kind === 'text') {
    return <p className={`whitespace-pre-wrap ${className}`}>{first.value}</p>;
  }
  return (
    <p className={`whitespace-pre-wrap ${className}`}>
      {segments.map((seg, i) =>
        seg.kind === 'phone' ? (
          <a
            key={i}
            href={telHref(seg.value)}
            className="font-medium text-[var(--accent)] underline-offset-2 hover:underline"
          >
            {seg.value}
          </a>
        ) : (
          <span key={i}>{seg.value}</span>
        )
      )}
    </p>
  );
}

function splitTextWithPhones(text: string): Array<{ kind: 'text' | 'phone'; value: string }> {
  const raw = text ?? '';
  const re = /(\+7[\d\s\-()]{10,}|8[\d\s\-()]{10,})/g;
  const out: Array<{ kind: 'text' | 'phone'; value: string }> = [];
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(raw)) !== null) {
    const chunk = m[1];
    if (!chunk) {
      continue;
    }
    if (m.index > last) {
      out.push({ kind: 'text', value: raw.slice(last, m.index) });
    }
    out.push({ kind: 'phone', value: chunk.trim() });
    last = m.index + chunk.length;
  }
  if (last < raw.length) {
    out.push({ kind: 'text', value: raw.slice(last) });
  }
  if (out.length === 0) {
    out.push({ kind: 'text', value: raw });
  }
  return out;
}
